module.exports = __webpack_public_path__ + "img/kaist_gallery10.71f81e2e.jpg";